<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import CitProblemForm from "@/components/partials/CitProblemForm/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";

export default {
  name: "ProblemFromFileModal",
  props: {
    request: {
      type: Object,
      required: true,
    },
    visible: Boolean,
    file: {
      required: true,
      type: Object,
    },
    filesList: Array,
    executive: Object,
    street: Object,
    priority: Object,
    address: String,
    title: String,
    actions: Array,
  },
  components: {
    "cit-problem-form": CitProblemForm,
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      modalVisible: false,
      selectedFiles: [this.file],
    };
  },
  methods: {
    async submit() {
      let formData = await this.$refs.cproblemForm.submit();
      if (this.selectedFiles.length == 0) {
        this.$message.error("Fayl seçilməyib");
        return;
      }
      formData.citRequestId = this.request.id;
      formData.files = this.selectedFiles;
      formData.coverMedia = this.selectedFiles[0].path;

      let message = this.$message;

      this.$confirm({
        title: "Əlavə edilsin?  ",
        //content: "",
        okText: "Bəli ",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url: URL[process.env.NODE_ENV].service_api + "operator/problems",
              method: "POST",
              data: formData,
            })
              .then((response) => {
                if (!response.data.error) {
                  message.success("Yeni şikayət əlavə edildi");
                  setTimeout(() => {
                    location.reload();
                  }, 1000);
                } else {
                  message.error(response.data.error.message);
                  reject();
                }
              })
              .catch((err) => {
                message.error("Xəta baş verdi");
                console.log(err);
                reject();
              });
          });
        },
        onCancel() {
          //console.log("Cancel");
        },
      });
    },
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (!oldValue && newValue && this.selected) {
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
